export default { sha: 'c7b43cd253a72672f0e08ed28fdf597a99e366a8', buildNumber: 'undefined' }
